import { render, staticRenderFns } from "./InputWithLabel.vue?vue&type=template&id=b2b2c4ac&scoped=true&"
import script from "./InputWithLabel.vue?vue&type=script&lang=js&"
export * from "./InputWithLabel.vue?vue&type=script&lang=js&"
import style0 from "./InputWithLabel.vue?vue&type=style&index=0&id=b2b2c4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b2c4ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2b2c4ac')) {
      api.createRecord('b2b2c4ac', component.options)
    } else {
      api.reload('b2b2c4ac', component.options)
    }
    module.hot.accept("./InputWithLabel.vue?vue&type=template&id=b2b2c4ac&scoped=true&", function () {
      api.rerender('b2b2c4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Input/InputWithLabel.vue"
export default component.exports